import React from 'react'
import FormSelect from 'components/forms/bases/FormSelect'

const OverflowSelector = ({
  ...props,
}) => {
  return (
    <FormSelect
      label="Overflow"
      value={props.value || 'initial'}
      options={
        ['initial', 'auto', 'scroll', 'hidden']
      }
      {...props}
    />
  )
}

OverflowSelector.propTypes = {}
OverflowSelector.defaultProps = {}

export default OverflowSelector



// WEBPACK FOOTER //
// ./src/components/forms/OverflowSelector.js